export const ADD_MACHINE_READING = "Add Master Reading"

